import { Instance, types } from "mobx-state-tree";

export const SharedOrgConfig = types.model({
  profanitiesCheckingEnabled: types.maybe(types.boolean),
  keyboardShortcutsEnabled: types.maybe(types.boolean),
  showAdviserLastNameEnabled: types.maybe(types.boolean),
  showAssignedAgentAvatarEnabled: types.maybe(types.boolean),
  cobrowseEnabled: types.boolean,
  forgetMeEnabled: types.boolean,
  continueConversationOnMobileEnabled: types.boolean,
  typingPreviewEnabled: types.boolean,
  callsDisabled: types.maybe(types.boolean),
  logoToken: types.maybe(types.string),
  coverToken: types.maybe(types.string),
  defaultAgentAvatarToken: types.maybe(types.string),
  color: types.string,
  agreement: types.string,
  name: types.string,
  allowedAttachmentExtensions: types.array(types.string),
  maximumAttachmentSizeBytes: types.maybe(types.number),
  messageMaxAllowedCharactersForClient: types.maybe(types.number),
  phoneRegion: types.string,
  webSpeechApiEnabled: types.maybe(types.boolean)
});
export interface ISharedOrgConfig extends Instance<typeof SharedOrgConfig> {}
